import { useState } from "react";
import { KeyRound, Mail, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";
import { toast } from "sonner";

export function MonCompte({ me }) {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.next.length < 8) { toast.error("Le nouveau mot de passe doit contenir au moins 8 caractères"); return; }
    if (form.next !== form.confirm) { toast.error("La confirmation ne correspond pas"); return; }
    setBusy(true);
    try {
      await api.post("/graphisme/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("Mot de passe modifié");
      setForm({ current: "", next: "", confirm: "" });
    } catch (err) { toast.error(err.response?.data?.detail || "Erreur lors de la modification"); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-4" data-testid="gclient-compte">
      <div className="bg-white border border-neutral-200 rounded-xl p-5 space-y-2">
        <h2 className="font-heading font-bold">Mon compte</h2>
        <div className="flex items-center gap-2.5 text-sm"><User className="w-4 h-4 text-neutral-400" /><span className="font-medium" data-testid="compte-name">{me?.name}</span></div>
        <div className="flex items-center gap-2.5 text-sm"><Mail className="w-4 h-4 text-neutral-400" /><span data-testid="compte-email">{me?.email}</span></div>
      </div>
      <form onSubmit={submit} className="bg-white border border-neutral-200 rounded-xl p-5 space-y-3" data-testid="compte-password-form">
        <h3 className="font-heading font-bold text-sm flex items-center gap-2"><KeyRound className="w-4 h-4" /> Changer mon mot de passe</h3>
        <div>
          <Label className="text-xs">Mot de passe actuel *</Label>
          <Input type="password" className="mt-1" value={form.current} required autoComplete="current-password"
            onChange={(e) => setForm({ ...form, current: e.target.value })} data-testid="compte-current" />
        </div>
        <div>
          <Label className="text-xs">Nouveau mot de passe (8 caractères min.) *</Label>
          <Input type="password" className="mt-1" value={form.next} required minLength={8} autoComplete="new-password"
            onChange={(e) => setForm({ ...form, next: e.target.value })} data-testid="compte-new" />
        </div>
        <div>
          <Label className="text-xs">Confirmation *</Label>
          <Input type="password" className="mt-1" value={form.confirm} required autoComplete="new-password"
            onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="compte-confirm" />
        </div>
        <Button type="submit" disabled={busy} className="bg-neutral-900 hover:bg-neutral-800 text-white" data-testid="compte-submit">
          {busy ? "Modification…" : "Modifier mon mot de passe"}
        </Button>
      </form>
    </div>
  );
}
